import React, { useEffect, useState } from 'react';
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';
import { FindAndReplace } from '../types';
import useGetFindAndReplaceHistory from './useFindAndReplaceHistory';
import Loading from '../../../../../components/Loading';
import FormHeader from '../../../../../kingpin/forms/FormHeader';
import FormContent from '../../../../../kingpin/forms/FormContent';
import Form from '../../../../../kingpin/forms/Form';
import FindAndReplaceHistoryReceipt from './FindAndReplaceHistoryReceipt';
import List from '../../../../../components/List';
import ListItem from '../../../DatasetDefinitions/DatasetsIndex/PerformanceDatasetWizard/ListItem';
import ColDiv from '../../../DatasetDefinitions/DatasetsIndex/PerformanceDatasetWizard/MetricsStep/ColDiv';
import Typography from '../../../../../kingpin/atoms/Typography';
import Icon from 'kingpin/atoms/Icon';
import captureException from 'services/captureException';

import { ArrowCol, COLUMN_FLEX, MenuCol } from './columns';

const Headings = () => (
  <ListItem isHeader>
    <ColDiv flex={COLUMN_FLEX.date}>
      <Typography.Body type="Label" isEllipsis>
        Date
      </Typography.Body>
    </ColDiv>
    <ColDiv flex={COLUMN_FLEX.findMetric}>
      <Typography.Body type="Label" isEllipsis>
        Original Metric
      </Typography.Body>
    </ColDiv>
    <ArrowCol>
      <Icon icon="arrow-right" color="var(--color-icon-tertiary)" />
    </ArrowCol>
    <ColDiv flex={COLUMN_FLEX.replaceMetric}>
      <Typography.Body type="Label" isEllipsis>
        Replace Metric
      </Typography.Body>
    </ColDiv>
    <ColDiv flex={COLUMN_FLEX.itemsAffected}>
      <Typography.Body type="Label" isEllipsis>
        Items affected
      </Typography.Body>
    </ColDiv>
    <MenuCol />
  </ListItem>
);
const FindAndReplaceHistory = ({ close }: { close: () => void }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [receipts, setReceipts] = useState<
    FindAndReplace.EnrichedMetricReceipt[]
  >([]);
  const getFindAndReplaceReceipts = useGetFindAndReplaceHistory();

  useEffect(() => {
    const getHistory = async () => {
      setIsLoading(true);
      try {
        setReceipts(await getFindAndReplaceReceipts());
      } catch (e) {
        captureException(e);
      } finally {
        setIsLoading(false);
      }
    };
    getHistory();
  }, [getFindAndReplaceReceipts]);
  return (
    <>
      {isLoading && <Loading />}
      <Form>
        <FormHeader title={'Find & Replace History'} onClose={close} />
        <FormContent>
          <List
            Headers={<Headings />}
            Body={
              <div style={{ maxHeight: 500, overflowY: 'auto' }}>
                {receipts.map((receipt) => (
                  <FindAndReplaceHistoryReceipt
                    key={receipt.id}
                    receipt={receipt}
                  />
                ))}
              </div>
            }
          />
        </FormContent>
      </Form>
    </>
  );
};

const Gate = ({ isOpen, close }: { isOpen: boolean; close: () => void }) => (
  <ModalTransition>
    {isOpen && (
      <ModalDialog
        width={800}
        onClose={close}
        shouldScrollInViewport={false}
        autoFocus={false}
      >
        <FindAndReplaceHistory close={close} />
      </ModalDialog>
    )}
  </ModalTransition>
);

export default Gate;
